 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		14: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		14: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"6e6f8b2149ec3f07ef058a1ed9fd5158b69da789","3":"961eef3ec7bc20f1354acbf7cbddd4c58e5c2654","4":"22855522eee13962bb2a002e1544b57d8ecb5a53","5":"6b9f8701da179c2061507c06800e36ff1e770991","6":"3e34bf6723fe509e707a0e23f88a5b911dcd1c7f","7":"e6dc50bb44c8429a1665e5329f81473f41583e5f","8":"2918490ad3f1d53ef34d6a8b174c0c9f85013b00","9":"6f3f8f0e05a7650dc46cf3d89c80daf10e3a4e24","10":"3be44c1217a853aeea281a8925b45a81bfcd366f","11":"872ea9a4efde73b7c47704ff17db65f098870326","12":"component---src-pages-home-index-tsx","13":"e76280a594cdae87570b456dcdc91690c9f6263e","16":"component---src-pages-404-js","17":"component---src-pages-blog-index-js","18":"component---src-pages-bon-podarunkowy-index-tsx","19":"component---src-pages-bydgoszcz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","20":"component---src-pages-cennik-index-tsx","21":"component---src-pages-gdansk-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","22":"component---src-pages-gdynia-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","23":"component---src-pages-gdynia-usuwanie-znamion-pieprzykow-tsx","24":"component---src-pages-index-js","25":"component---src-pages-katowice-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","26":"component---src-pages-katowice-usuwanie-znamion-pieprzykow-tsx","27":"component---src-pages-kontakt-index-tsx","28":"component---src-pages-krakow-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","29":"component---src-pages-krakow-usuwanie-znamion-pieprzykow-tsx","30":"component---src-pages-lodz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","31":"component---src-pages-lodz-usuwanie-znamion-pieprzykow-tsx","32":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-index-tsx","33":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-o-kampanii-tsx","34":"component---src-pages-o-nas-index-tsx","35":"component---src-pages-poznan-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","36":"component---src-pages-poznan-konsultacje-onkologiczne-leczenie-czerniaka-tsx","37":"component---src-pages-poznan-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","38":"component---src-pages-poznan-usuwanie-znamion-pieprzykow-tsx","39":"component---src-pages-szczecin-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","40":"component---src-pages-szczecin-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","41":"component---src-pages-szczecin-usuwanie-znamion-pieprzykow-tsx","42":"component---src-pages-tags-index-tsx","43":"component---src-pages-warszawa-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","44":"component---src-pages-warszawa-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","45":"component---src-pages-warszawa-usuwanie-znamion-pieprzykow-tsx","46":"component---src-pages-wroclaw-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","47":"component---src-pages-wroclaw-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","48":"component---src-pages-wroclaw-usuwanie-znamion-pieprzykow-tsx","49":"component---src-pages-zywiec-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","50":"component---src-templates-article-js","51":"component---src-templates-blog-post-js","52":"component---src-templates-tags-js"}[chunkId]||chunkId) + "-" + {"0":"dc02e41c1449a877f5cf","1":"e9d24b1846c7d6eb9685","2":"1e68866f033f55310e7b","3":"75fab48a3c435dc3d6b4","4":"5131d6dcb97bcd3485ba","5":"5cfb802e99416a92deba","6":"cd71d249194b87db7107","7":"bfb92e6fa8dfdab455fd","8":"30123576b0ac7ca9ca9e","9":"6fd30d19a63fc81a07b7","10":"b0d3e95009ef1bdbf9c1","11":"cec6ffd18b438149d420","12":"27c0a9d9b6498d998352","13":"964515f54d81a6051f2a","16":"6b301b441b108d05062a","17":"e9e98651e0e9712c721b","18":"eeed5b37e72041b8a098","19":"2a08b3f0a4490258f930","20":"c9c4233056a72f77cf53","21":"2c90ee94a2b3edd8991a","22":"49c6963600184fc388ae","23":"fe25214ec074f755c907","24":"5f140b00f8c477207c30","25":"252d3944596f01a3fea6","26":"fec2ca6a61aa5a024ecc","27":"d881b200f6a01bb658b4","28":"b53c14995e932c2ca968","29":"3cf710ec7cc908bad8c5","30":"96fb892a88fb963a8fd3","31":"2985df99f68bb7eeb31a","32":"790eb39b84f7e7f73663","33":"573ff111985a2dca9c9f","34":"3a9c1ceb605ffc3c81b3","35":"9396f360b898f3d1caec","36":"a6c512dd2589907f5c35","37":"b5beba2da1314358fa07","38":"3cd2566ac23105f06715","39":"ee661a9a5e276c5f42cf","40":"2b061f423952c43f0ce9","41":"33a66f9ac0b0150ca4af","42":"af5c3d04678704aceea3","43":"9bbf3887cf304eab095c","44":"281dfd1ffd893aa68ff1","45":"e2143d86f146c1368585","46":"73a9e3fadcf90c15a6bb","47":"fa685ac2baa111e612d2","48":"504477c386ce1653b776","49":"460de5e9e122d3a18a9a","50":"3b8d1d5acebf9aab197b","51":"e8974d30c7c9d887de38","52":"13e777a42ac65c0c6f5c","55":"391014331b002ca7bc49"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"6e6f8b2149ec3f07ef058a1ed9fd5158b69da789","3":"961eef3ec7bc20f1354acbf7cbddd4c58e5c2654","4":"22855522eee13962bb2a002e1544b57d8ecb5a53","5":"6b9f8701da179c2061507c06800e36ff1e770991","6":"3e34bf6723fe509e707a0e23f88a5b911dcd1c7f","7":"e6dc50bb44c8429a1665e5329f81473f41583e5f","8":"2918490ad3f1d53ef34d6a8b174c0c9f85013b00","9":"6f3f8f0e05a7650dc46cf3d89c80daf10e3a4e24","10":"3be44c1217a853aeea281a8925b45a81bfcd366f","11":"872ea9a4efde73b7c47704ff17db65f098870326","12":"component---src-pages-home-index-tsx","13":"e76280a594cdae87570b456dcdc91690c9f6263e","16":"component---src-pages-404-js","17":"component---src-pages-blog-index-js","18":"component---src-pages-bon-podarunkowy-index-tsx","19":"component---src-pages-bydgoszcz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","20":"component---src-pages-cennik-index-tsx","21":"component---src-pages-gdansk-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","22":"component---src-pages-gdynia-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","23":"component---src-pages-gdynia-usuwanie-znamion-pieprzykow-tsx","24":"component---src-pages-index-js","25":"component---src-pages-katowice-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","26":"component---src-pages-katowice-usuwanie-znamion-pieprzykow-tsx","27":"component---src-pages-kontakt-index-tsx","28":"component---src-pages-krakow-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","29":"component---src-pages-krakow-usuwanie-znamion-pieprzykow-tsx","30":"component---src-pages-lodz-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","31":"component---src-pages-lodz-usuwanie-znamion-pieprzykow-tsx","32":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-index-tsx","33":"component---src-pages-nie-przekonuj-sie-na-wlasnej-skorze-o-kampanii-tsx","34":"component---src-pages-o-nas-index-tsx","35":"component---src-pages-poznan-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","36":"component---src-pages-poznan-konsultacje-onkologiczne-leczenie-czerniaka-tsx","37":"component---src-pages-poznan-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","38":"component---src-pages-poznan-usuwanie-znamion-pieprzykow-tsx","39":"component---src-pages-szczecin-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","40":"component---src-pages-szczecin-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","41":"component---src-pages-szczecin-usuwanie-znamion-pieprzykow-tsx","42":"component---src-pages-tags-index-tsx","43":"component---src-pages-warszawa-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","44":"component---src-pages-warszawa-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","45":"component---src-pages-warszawa-usuwanie-znamion-pieprzykow-tsx","46":"component---src-pages-wroclaw-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","47":"component---src-pages-wroclaw-laserowe-usuwanie-znamion-pieprzykow-wlokniakow-brodawek-kurzajek-tsx","48":"component---src-pages-wroclaw-usuwanie-znamion-pieprzykow-tsx","49":"component---src-pages-zywiec-dermatoskopowe-badanie-znamion-wideodermatoskopia-tsx","50":"component---src-templates-article-js","51":"component---src-templates-blog-post-js","52":"component---src-templates-tags-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f023600db270782d0ca1","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
